import { FtlRoutingViewModel } from "../../../../../ViewModel/FtlRoutingViewModel";
import { ProjectStateType } from "../../../../EditProjectContext";
import { FtlRouteViewModel } from "../../../../../ViewModel/FtlRouteViewModel";

export const setRoutingTable = (
  routeId: number,
  routingTable: Array<FtlRoutingViewModel>,
  { project, setProject }: ProjectStateType
) => {
  const updateFtlRoute = (ftlRoute: FtlRouteViewModel) => {
    return ftlRoute.RouteId === routeId
      ? {
          ...ftlRoute,
          RoutingTable: routingTable,
        }
      : ftlRoute;
  };

  setProject({
    ...project,
    FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
  });
};
